import { LoadingPage } from '@pm/core/src/pages/LoadingPage';
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { usePatientProfile } from '../../hooks/profile';
import PhoneVerification from './PhoneVerification';

type VerifyPhoneRoutesProps = {
  supportLink: string;
};

// entry route: /verify-phone
function VerifyPhoneRoutes({ supportLink }: VerifyPhoneRoutesProps) {
  const {
    profile: {
      phone: { e164: phoneNumber },
      voicemailConsent,
    },
    loading,
  } = usePatientProfile();
  const navigate = useNavigate();

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <Routes>
      <Route
        index
        element={
          <PhoneVerification
            supportLink={supportLink}
            voicemailConsent={voicemailConsent}
            phoneNumber={phoneNumber}
            onComplete={() => {
              navigate('/');
            }}
          />
        }
      />
      {/*
        `..` pops to the parent match, which is this module's mount base under
        both React Router v6 and v7. A bare `.` reads the leaf match, which in
        v7 includes the matched splat — so it would redirect onto itself.
      */}
      <Route path="*" element={<Navigate to=".." replace />} />
    </Routes>
  );
}

export default VerifyPhoneRoutes;
